import * as React from 'react';
import styled from 'styled-components';
import MuiListItemIcon, { ListItemIconProps as MuiListItemIconProps } from '@material-ui/core/ListItemIcon';

const StyledListItemIcon = styled(MuiListItemIcon)``;

export type DSListItemIconProps = MuiListItemIconProps;
export const DSListItemIcon: React.FC<DSListItemIconProps> = props => <StyledListItemIcon {...props} />;
DSListItemIcon.displayName = 'DSListItemIcon';
